import {
  useMutation,
  useQueryClient,
} from "@tanstack/react-query"

import { api } from "@/api"
import { BASE_URL, ENDPOINTS } from "@/constants"
import { useAuth } from "@/contexts/auth"
interface CancelOrderProps {
  reason: string
  orderId: string
}
export const useCancelOrderMutation = (
  orderCode: string
) => {
  const queryClient = useQueryClient()
  const { authData } = useAuth()
  return useMutation({
    mutationFn: async ({
      reason,
      orderId,
    }: CancelOrderProps) => {
      const url = `${BASE_URL}${ENDPOINTS.ORDER_CANCEL}/${orderId}/by_store`
      const body = {
        data: {
          reason,
          user_id: authData?.user.merchantId,
        },
      }
      await api.delete(url, body)
    },
    onSuccess: async (_, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.RECEIVABLE, variables.orderId],
      })
      await queryClient.invalidateQueries({
        queryKey: [
          "orders",
          { code: orderCode, page: 1, pageSize: 10 },
        ],
      })
    },
  })
}
